import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import Footer from '../../components/Footer2';
import Header from '../../components/Header/index';
import './VideoPage.css';
import { notice } from '../../store/actions/auth';

class VideoPage extends Component {
  state = {
    finalVideo: false,
    isCheck: false,
    lastNoticeState: '',
  };

  componentDidMount() {
    if (this.props.users?.signedUser?.lastNotice) {
      this.props.history.push('/home');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.users?.signedUser?.lastNotice) {
      this.props.history.push('/home');
    }
  }

  chegouFinal = () => {
    this.setState({
      finalVideo: true,
    });
  };

  clickCheck = () => {
    if (this.state.isCheck === true) {
      this.setState({
        lastNoticeState: 'video',
      });
    } else if (this.state.isCheck === false) {
      this.setState({
        lastNoticeState: '',
      });
    }
    this.setState({
      isCheck: !this.state.isCheck,
    });
  };

  pularVideo = () => {
    this.props.notice(this.props.users, this.state.isCheck);
  };

  render() {
    const { finalVideo, isCheck } = this.state;

    return (
      <div className="container-video-page">
        <Header pagetype="page-inicio" />
        <div className="container-player">
          <div className="div-text">
            <p className="txt-title">Seja bem-vindo a Boteria!</p>
            <p className="txt-subtitle">
              Estamos muito felizes com seu interesse e preparamos esse vídeo
              para ajudar em seu primeiro bot:
            </p>
          </div>
          {finalVideo === true && (
            <div className="final-video-tela">
              <Link to="/home">
                <button type="button" className="btn-video">
                  começar a criar bots
                </button>
              </Link>
            </div>
          )}
          <video
            preload="auto"
            controls
            width="800px"
            height="450px"
            onEnded={this.chegouFinal}
          >
            <track kind="captions" />
            <source
              src="https://storage.googleapis.com/boteria-videos/v.mp4"
              type="video/mp4"
            />
          </video>
          <div className="container-footer-video">
            <div className="form-check">
              <input
                type="checkbox"
                disabled={false}
                checked={isCheck}
                onChange={this.clickCheck}
                className="form-check-input"
                id="no-video-active"
              />
              <label className="form-check-label" htmlFor="no-video-active">
                Não exibir este vídeo novamente
              </label>
            </div>

            <div className="container-footer-find">
              <span>Ficou com alguma dúvida?</span>
              <a target="_brank" href="https://code7.com/faq/boteria/">
                <button type="button" className="btn-video">
                  central de ajuda
                </button>
              </a>
              <span onClick={this.pularVideo}>
                <Link to="/home">
                  <span className="txt-pular">Pular vídeo {'>'}</span>
                </Link>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ notice }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VideoPage))
);
